import { render, staticRenderFns } from "./AuthPanel.vue?vue&type=template&id=2ca7cb30&lang=pug&"
import script from "./AuthPanel.vue?vue&type=script&lang=js&"
export * from "./AuthPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports